import { useEffect } from 'react';
declare global {
  interface Window {
    dataLayer: any;
  }
}

interface UseGoogleAnalyticsProps {
  pushToDataLayer: (data: any) => void;
}

const useGoogleAnalytics = (): UseGoogleAnalyticsProps => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    return () => {};
  }, []);

  const pushToDataLayer = (data: any): void => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  };

  return {
    pushToDataLayer,
  };
};

export default useGoogleAnalytics;
